export const FAVORITES = 'favorites';
export const LAST_SAVED = 'last_saved';
export const MAIN = 'main';
export const MY_GLOBAL_ITEMS = 'my_global_items';
export const GLOBAL_ITEMS = 'global_items';
export const SAVED_FROM_STORE = 'saved_from_store';

export const ALL_MY_ITEMS_GROUPS = [FAVORITES, LAST_SAVED, MAIN, MY_GLOBAL_ITEMS, GLOBAL_ITEMS, SAVED_FROM_STORE];
